<template>
<div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
        <app-sidebar></app-sidebar>
        <div id="page-content-wrapper" style="width:100%">
            <i class="material-icons" id="menu-toggle" @click="isSidebar = !isSidebar" style="cursor:pointer">view_headline</i>
            <app-navbar></app-navbar>
            <div class="container-fluid mt-5">
                <div class="col-sm-12">
                    <div class="row dblock" style="padding: 5px;box-shadow: 0 0 15px 0 rgba(0,0,0,.05);">
                        <div class="row">
                            <div class="col-md-12">
                                <vs-breadcrumb align="left" :items="[
                      { title: 'You are here : ' },
                      {
                        title: 'Dashboard',
                        url: '/#/dashboard/Admin/adminDashboard'
                      },
                      {
                        title: 'Add Academic Information',
                        url: '/#/dashboard/Admin/academicInfo',
                        active: true
                      }
                    ]"></vs-breadcrumb>
                                <div class="heading mt-3">
                                    <h3 class="text-secondary">Academic Information</h3>
                                </div>
                            </div>
                        </div>

                        <div class="form-row">
                            <h6 class="sub-frm-title">Add Academic Information(s)</h6>
                            <div class="col-sm-12">
                                <b-card v-if="isForm" style="border: 1px dotted #07a7e14f;">
                                    <form @submit.prevent="submitForm">
                                        <div class="form-group">
                                            <div class="row">
                                                <!-- floating input starts -->
                                                <div class="col-sm-12">
                                                    <div class="floating-label">
                                                        <input class="floating-input form-control" v-model="title" type="text" placeholder=" " />
                                                        <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                                            <i class="material-icons" style="font-size: 20px;"></i>
                                                        </span>
                                                        <label class="lbl-label">
                                                            Degree / Certificate
                                                            <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <div class="row">
                                                <div class="col-sm-12">
                                                    <!-- add button starts-->
                                                    <b-button class="save-btn" type="submit" variant="primary">Add</b-button>
                                                    <!-- add button ends -->
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </b-card>

                                <!-- Edit form starts here -->
                                <b-card v-if="isEditForm" style="border: 1px dotted #07a7e14f;">
                                    <form @submit.prevent="submitEditForm">
                                        <div class="form-group">
                                            <div class="row">
                                                <!-- floating input starts -->
                                                <div class="col-sm-12">
                                                    <div class="floating-label">
                                                        <input class="floating-input form-control" v-model="title" type="text" placeholder=" " />
                                                        <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                                            <i class="material-icons" style="font-size: 20px;"></i>
                                                        </span>
                                                        <label class="lbl-label">Degree / Certificate</label>
                                                    </div>
                                                </div>
                                                <!-- floating input ends -->
                                            </div>
                                        </div>
                                        <input type="hidden" v-model="designationId" />
                                        <div class="form-group">
                                            <div class="row">
                                                <div class="col-sm-12">
                                                    <!-- add button starts-->
                                                    <b-button pill type="submit" class="save-btn" variant="primary">Update</b-button>
                                                    <b-button pill v-if="!isForm" @click="closeEditForm" variant="outline-info">Cancel</b-button>
                                                    <!-- add button ends -->
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </b-card>
                                <!-- // End of Edit form -->
                            </div>
                            <div class="col-sm-12">
                                <!-- new form popup starts -->
                                <b-card>
                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <div class="table-responsive">
                                                    <table class="table table-hover">
                                                        <tr>
                                                            <th>Sr#</th>
                                                            <th>Degree / Title</th>
                                                            <th>Added at</th>
                                                            <th>Action</th>
                                                        </tr>
                                                        <tr v-for="(item, index) in items" v-bind:key="item.id">
                                                            <td>{{ index + 1 }}</td>
                                                            <td class="text-capitalize">{{ item.title }}</td>
                                                            <td>{{ item.createdAt | formatDate }}</td>
                                                            <td>
                                                                <a @click="editRecord(item.id)">
                                                                    <vs-icon class="mr-4" icon="edit" style="color:#007bff;font-size:20px;font-weight:600;cursor: pointer;"></vs-icon>
                                                                </a>
                                                                <a @click="deleteRecord(item.id)">
                                                                    <vs-icon class="mr-1" icon="delete" style="color:#ff0000c7;font-size:20px;font-weight:600;cursor: pointer;"></vs-icon>
                                                                </a>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </b-card>
                                <!-- new form popup ends -->
                            </div>
                        </div>
                        <!-- save button starts-->

                        <!-- save button ends -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";

// Import date picker css
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
export default {
    data: () => ({
        title: "",
        error: "",
        success: "",
        isSidebar: false,
        isForm: true,
        isFormData: false,
        selected: "",
        formArr: 1,
        counterDanger: false,
        colorx: "#1db952",
        select1Normal: "",
        select1: 1,
        items: []
    }),
    mounted() {
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        this.allAcadmic();
    },
    components: {
        "app-navbar": Navbar,
        "app-sidebar": Sidebar
    },
    methods: {
        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },

        allAcadmic: function allAcadmic() {
            this.openLoading();
            axios
                .get(process.env.VUE_APP_BASE_PATH + "/degreenames/get")
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.items = response.data;
                });
        },
        toastSuccess(msg) {
            this.$bvToast.toast(msg, {
                title: "Success",
                autoHideDelay: 10000,
                variant: "success",
                solid: true
            });
        },
        toastError(msg) {
            this.$bvToast.toast(msg, {
                title: "Error",
                autoHideDelay: 10000,
                variant: "danger",
                solid: true
            });
        },
        showForm() {
            this.isForm = false;
            this.isFormData = true;
        },
        closeEditForm() {
            this.isForm = true;
            this.isEditForm = false;
            this.title = "";
        },
        editRecord(id) {
            this.isForm = false;
            this.isEditForm = true;
            this.openLoading();
            axios
                .get(process.env.VUE_APP_BASE_PATH + "/degreenames/" + id + "/edit")
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    if (response) {
                        this.title = response.data.title;
                        this.designationId = response.data.id;
                        window.scrollTo(0, 0);
                    }
                });
        },
        deleteRecord(id) {
            // alert("ID '" +id+ "' is being deleted.");
            this.$bvModal
                .msgBoxConfirm("Please confirm that you want to delete?", {
                    title: "Please Confirm",
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "danger",
                    okTitle: "Delete",
                    cancelTitle: "Cancel",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    if (value == true) {
                        this.openLoading();
                        axios
                            .post(process.env.VUE_APP_BASE_PATH + "/degreenames/delete", {
                                id: id
                            })
                            .then(response => {
                                this.closeLoading();
                                if (response.data.success) {
                                    this.$toasted.global.successMsg("Record has been deleted successfully!");
                                    this.allAcadmic();
                                } else if (response.data.error) {
                                    throw response.data.error;
                                }
                            })
                            .catch(error => {
                                this.$toasted.global.errorMsg(error);
                            });
                    }
                });
        },
        // This will submit form
        submitForm(e) {
            let self = this;
            e.preventDefault();
            if (this.title == "" && this.code == "") {
                this.error = "All fields are required. Fill out all fields, please!";
            } else {
                // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
                this.openLoading();
                axios
                    .post(process.env.VUE_APP_BASE_PATH + "/degreenames/add", {
                        title: this.title
                    })
                    .then(response => {
                        this.closeLoading();
                        if (response.data.success) {
                            self.toastSuccess("Record has been saved successfully!");
                            self.allAcadmic();
                            self.resetForm();
                        } else if (response.data.error) {
                            throw response.data.error;
                        }
                    })
                    .catch(error => {
                        self.toastError(error);
                    });
            }
        },

        // This will update record
        submitEditForm(e) {
            e.preventDefault();
            this.inValid = [];
            let self = this;
            if (!this.title) {
                this.inValid.push("Title is required.");
            }
            for (var i = 0; i < this.inValid.length; i++) {
                this.$toasted.global.errorMsg(this.inValid[i]);
            }
            if (!this.inValid.length) {
                this.openLoading();
                axios
                    .post(process.env.VUE_APP_BASE_PATH + "/degreenames/update", {
                        title: this.title,
                        id: this.designationId
                    })
                    .then(response => {
                        this.closeLoading();
                        if (response.data.success) {
                            self.toastSuccess("Record has been updated successfully!");
                            //  self.resetForm();
                            self.allAcadmic();
                            self.closeEditForm();
                        } else if (response.data.error) {
                            throw response.data.error;
                        }
                    })
                    .catch(error => {
                        self.toastError(error);
                    });
            }
        },
        resetForm() {
            this.title = "";
        }
    }
};
</script>

<style scoped>
#menu-toggle {
    display: none;
}

@media (max-width: 768px) {
    #menu-toggle {
        display: block;
    }
}

.dblock {
    display: block !important;
}

.input-color {
    margin-bottom: 10px;
    position: relative;
    display: block;
}

.myNavbar {
    color: rgb(255, 255, 255);
}

.dflex {
    display: flex;
}

.fcenter {
    justify-content: center;
    align-items: center;
}

.pleft-5 {
    margin-left: 5px;
}

.selectExample {
    margin: 10px;
}

.con-select-example {
    display: flex;
    align-items: center;
    justify-content: center;
}

.con-select .vs-select {
    width: 100%;
}

@media (max-width: 550px) {
    .con-select {
        flex-direction: column;
    }

    .con-select .vs-select {
        width: 100%;
    }
}

.form-row {
    padding: 8px;
    color: #1465a3;
    border: 1px dotted #07a7e14f;
    margin-left: 0px !important;
    margin-right: 0px !important;
}

.field {
    width: 100%;
    text-transform: capitalize;
    border-bottom: 2px solid #d0d0d0;
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    box-shadow: none !important;
    border-radius: 0 !important;
    transition: all 0.2s ease-in-out 0.2s;
    -webkit-transition: all 0.2s ease-in-out 0.2s;
    -moz-transition: all 0.2s ease-in-out 0.2s;
}

.sub-frm-title {
    padding: 5px;
    background-color: #fff;
    margin-top: -25px;
    text-align: center;
    color: rgba(7, 167, 225, 0.61);
}

/* overide css of vuesax */
.vs-con-input-label {
    width: 100% !important;
}

.vs-con-input-label.is-label-placeholder {
    margin-top: 8px !important;
}

.frm-title {
    text-align: center;
    padding: 10px;
    color: #009ad2;
    /* border-bottom: 2px solid #009ad2; */
}

.addnew-btn {
    font-size: 12px;
    box-shadow: none;
    border-color: #6c757d;
    background-color: #6c757d;
    float: right;
    margin: 10px 0px;
}

.save-btn {
    box-shadow: none;
    font-size: 12px;
    border-color: rgba(7, 167, 225, 0.61);
    background-color: rgba(7, 167, 225, 0.61);
    float: right;
    margin: 10px 0px;
}

.delete-btn {
    font-size: 12px;
    box-shadow: none;
    /* border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61); */
    float: right;
    margin: 10px 0px 0px 5px;
}

.add-locations-btn {
    box-shadow: none;
    border-color: rgba(7, 167, 225, 0.61);
    background-color: rgba(7, 167, 225, 0.61);
    margin: 10px 0px;
}

.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show>.btn-primary.dropdown-toggle {
    color: #fff;
    border-color: rgba(7, 167, 225, 0.61);
    background-color: rgba(7, 167, 225, 0.61);
}

.new-training {
    padding-right: 10px;
}

.title-text {
    margin-bottom: 0px;
}

.selectize-control.multi .selectize-input>div {
    background: rgba(7, 167, 225, 0.61);
    color: #333333;
}

.con-select {
    font-size: 0.85rem !important;
}

.selectize-input.items.not-full.has-options.has-items {
    font-size: 0.85rem !important;
}

/* Floating label css starts */
/****  floating-Lable style start ****/
.floating-label {
    position: relative;
    margin-bottom: 5px;
}

.floating-input,
.floating-select {
    font-size: 14px;
    padding: 4px 30px 4px 5px;
    display: block;
    width: 100%;
    height: 36px;
    box-shadow: none !important;
    /* background-color: transparent; */
    border: none;
    border: 1px solid #ccc;
}

.floating-input:focus,
.floating-select:focus {
    outline: none;
    border: 2px solid rgba(7, 167, 225, 0.61);
}

label.lbl-label {
    color: #ccc;
    font-size: 14px;
    font-weight: normal;
    position: absolute;
    pointer-events: none;
    left: 5px;
    top: 6px;
    transition: 0.2s ease all;
    -moz-transition: 0.2s ease all;
    -webkit-transition: 0.2s ease all;
}

.floating-input:focus~label.lbl-label,
.floating-input:not(:placeholder-shown)~label.lbl-label {
    background-color: #ffffff;
    /* background-color: #fff; */
    top: -12px;
    left: 10px;
    font-size: 14px;
    color: rgba(7, 167, 225, 0.61);
    padding: 0px 5px;
}

.floating-select:focus~llabel.lbl-label,
.floating-select:not([value=""]):valid~label.lbl-label {
    top: -18px;
    font-size: 14px;
    color: #5264ae;
}

/* active state */
.floating-input:focus~.bar:before,
.floating-input:focus~.bar:after,
.floating-select:focus~.bar:before,
.floating-select:focus~.bar:after {
    width: 50%;
}

*,
*:before,
*:after {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}

/* highlighter */
/* .highlight {
  position: absolute;
  height: 50%;
  width: 100%;
  top: 15%;
  left: 0;
  pointer-events: none;
  opacity: 0.5;
} */

/* active state */
.floating-input:focus~.highlight,
.floating-select:focus~.highlight {
    -webkit-animation: inputHighlighter 0.3s ease;
    -moz-animation: inputHighlighter 0.3s ease;
    animation: inputHighlighter 0.3s ease;
}

/* animation */
@-webkit-keyframes inputHighlighter {
    from {
        background: #5264ae;
    }

    to {
        width: 0;
        background: transparent;
    }
}

@-moz-keyframes inputHighlighter {
    from {
        background: #5264ae;
    }

    to {
        width: 0;
        background: transparent;
    }
}

@keyframes inputHighlighter {
    from {
        background: #5264ae;
    }

    to {
        width: 0;
        background: transparent;
    }
}

/****  floating-Lable style end ****/

/* Floating label css ends */

.display-table ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
}

.display-table li {
    float: left;
    padding: 5px 5px;
}

.display-table li a {
    cursor: inherit;
    font-size: 14px;
    display: block;
    color: #747679;
    text-align: center;
    padding: 5px;
    text-decoration: none;
    background-color: #f1f1f1;
}

.tbl-head th {
    font-weight: 400 !important;
    color: rgba(7, 167, 225, 0.61);
}

.display-table {
    /* margin-bottom: 0px !important; */
    color: #8e8e8e;
}

.display-table th,
.display-table td {
    padding: 5px 10px !important;
    /* border: 1px dotted #07a7e14f; */
}
</style>
